<template>
  <div v-if="isAvailable" :class="{'active-box': isActive}">
    <router-link
      :to="{name: `${ routerLink }`, params: {form, formid: form.FormID}}"
      class="form-preview"
      :class="classObject"
    >
      <div class="form-year">{{schoolYear}}</div>
      <div class="form-period">{{periodMap[form.Period].deAbreviated}}</div>
      <hr />
      <div class="preview-body">
        <div class="form-description">{{formDescription}}</div>
        <div class="submit-status-container">
          <div class="check" v-if="form.status === `Submitted`">&#10004;</div>
          <div
            :class="{'is-submitted': form.status === `Submitted`, 'not-submitted': form.status !== `Submitted`}"
          >{{form.status}}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      periodMap: {
        EOY: { deAbreviated: "End of Year", short: "end" },
        MOY: { deAbreviated: "Middle of Year", short: "middle" },
        BOY: { deAbreviated: "Beginning of Year", short: "beginning" }
      },
      monthMap: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      dayMap: {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday"
      }
    };
  },
  computed: {
    isActive() {
      const now = new Date().getTime();
      return (
        now <= new Date(this.form.CloseWindow.slice(0, 10)).getTime() &&
        now >= new Date(this.form.OpenWindow.slice(0, 10)).getTime()
      );
    },
    routerLink() {
      if (!this.isActive) return '';
      return this.form.status === `Submitted` ? `goalsettingform` : `newgoalsettingform`;
    },
    formDescription() {
      return this.isActive
        ? `This form is currently active and you may fill it out until ${this.displayEndDate}`
        : `This is the form you filled out in the ${
            this.periodMap[this.form.Period].short
          } of the ${this.form.FiscalYear} school year.`;
    },
    classObject() {
      return {
        "eoy-form": this.form.Period === "EOY",
        "moy-form": this.form.Period === "MOY",
        "boy-form": this.form.Period === "BOY",
        active:
          new Date().getTime() <=
          new Date(this.form.CloseWindow.slice(0, 10)).getTime()
      };
    },
    schoolYear() {
      return `${this.form.FiscalYear - 1} - ${this.form.FiscalYear}`;
    },
    isAvailable() {
      return new Date(this.form.OpenWindow).getTime() <= new Date().getTime();
    },
    displayEndDate() {
      const { CloseWindow } = this.form;
      const closeDate = new Date(CloseWindow);
      const dateObj = {
        day: this.dayMap[closeDate.toString().slice(0, 3)],
        month: this.monthMap[closeDate.getMonth()],
        year: closeDate.getFullYear()
      };
      return `${dateObj.day} ${dateObj.month} ${closeDate.getDate()}, ${
        dateObj.year
      }`;
    },
  }
};
</script>

<style scoped>
.submit-status-container {
  display: flex;
  align-items: center;
}
.check {
  color: white;
  font-size: 1.6em;
  padding: 0 0.6em 0 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
}
div {
  font-family: Arial;
}
.active-box {
  border: 4px solid;
  margin: 0.5em;
}
.form-year {
  font-size: 1.5em;
  color: #ffffff;
  margin: 10px 32px 0px 32px;
}
.form-period {
  min-width: 50px;
  max-width: 105px;
  font-size: 1.5em;
  font-weight: bold;
  color: #ffffff;
  margin: 8px 0px 25.5px 0px;
}
.preview-body {
  height: 58%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.form-preview {
  width: 17em;
  height: 25em;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 14px 15px 14px 15px;
  text-decoration: none;
}
hr {
  width: 100%;
  height: 1px;
  border: solid 1px #ffffff;
}
.form-description {
  padding: 1.15em 1.15em;
  min-width: 120px;
  min-height: 56px;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #ffffff;
}
.is-submitted {
  color: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1em;
  height: 100%;
  display: flex;
  align-items: flex-end;
}
.not-submitted {
  color: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1em;
  padding-left: 1em;
}
.eoy-form {
  background-color: #257d8c;
}
.moy-form {
  background-color: #ae6401;
}
.boy-form {
  background-color: #5d4761;
}
</style>